import { axiosMeedioClient } from './client';
import { CreateMeetingRequest, MeetingResponse } from './types';

export const createMeeting = async (payload: CreateMeetingRequest) => {
  const { data } = await axiosMeedioClient.post<MeetingResponse>('/meetings', payload);
  return data;
};
